import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { formatCurrency, formatNumber } from 'utils/formats';

import { useAcceptIncentiveOfferModal } from '../context/AcceptIncentiveOfferModalContext';

const AcceptIncentiveOfferModalStep1: FC = () => {
  const { t } = useTranslate();
  const { data } = useAcceptIncentiveOfferModal();

  return (
    <div className="nk-stepper-step active">
      <div className="text-center mb-4">
        <em className="icon ni ni-file-text fs-24px text-primary" />
        <h5 className="mt-2">{t('OperationSummary')}</h5>
        <p className="text-soft">
          {t('ReviewPurchaseDetailsBeforeContinuing')}
        </p>
      </div>

      <div className="card card-bordered bg-light">
        <div className="card-inner">
          <div className="row">
            <div className="col-6 my-2">
              <span className="text-soft d-block fs-12px">
                {t('OfferReference')}
              </span>
              <strong>{data.offerReference}</strong>
            </div>
            <div className="col-6 my-2">
              <span className="text-soft d-block fs-12px">{t('Seller')}</span>
              <strong>{data.sellerName}</strong>
            </div>

            {data.buyerPlansLabel && (
              <div className="col-6 my-2">
                <span className="text-soft d-block fs-12px">{t('Plan')}</span>
                <strong>{data.buyerPlansLabel}</strong>
              </div>
            )}

            <div className="col-6 my-2">
              <span className="text-soft d-block fs-12px">
                {t('IncentivesMarketUnitsToBuy')}
              </span>
              <strong className="text-info">
                {formatNumber(data.purchaseQuantity)}{' '}
                {t('IncentivesMarketUnits').toLowerCase()}
              </strong>
            </div>
            <div className="col-6 my-2">
              <span className="text-soft d-block fs-12px">
                {t('IncentivesMarketPricePerUnit')}
              </span>
              <strong>{formatCurrency(data.offer.unitPrice)}</strong>
            </div>
            <div className="col-6 my-2">
              <span className="text-soft d-block fs-12px">
                {t('TotalAmount')}
              </span>
              <strong className="text-info fs-16px">
                {formatCurrency(data.totalPrice)}
              </strong>
            </div>
          </div>
        </div>
      </div>

      <div className="alert alert-warning alert-icon mt-3">
        <em className="icon ni ni-alert-circle" />
        <p className="mb-0 fs-13px">{t('AcceptOfferWarningMessage')}</p>
      </div>
    </div>
  );
};

export default AcceptIncentiveOfferModalStep1;
